import styled from 'styled-components';
import { Heading } from 'evergreen-ui';

const Title = styled(Heading)`
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 20px;
`;

export default Title;
